import React from "react";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div>
      <h1>Word Dash</h1>
      <div className="menu">
        <Link to="/single-player">
          <button>Solo</button>
        </Link>
        <Link to="/multiplayer">
          <button>Race</button>
        </Link>
      </div>
    </div>
  );
}

export default Home;
